import { Record } from 'immutable';
import { schema } from 'normalizr';

export const CameraSchedule = new Record({
  id: undefined,
  camera: undefined,
  time: undefined,
  days: undefined,
  interval: undefined,
  enabled: undefined,
});

export const cameraScheduleSchema = new schema.Entity('cameraSchedules');

// for reading in nested models, object with { field: schema }
// cameraScheduleSchema.define({  });
